export const CREATE_RONDO_GAME_COMPLETED = "rondo/createGameCompleted";
export const GET_RONDO_GAME_COMPLETED = "rondo/getGameCompleted";
export const ANSWER_RONDO_LETTER_COMPLETED = "rondo/answerLetterCompleted";
export const SKIP_RONDO_LETTER_COMPLETED = "rondo/skipLetterCompleted";
export const COMPLETE_RONDO_GAME_COMPLETED = "rondo/completeGameCompleted";